import { formatDate } from "services";
import { DateTime } from "enums";
import { filterRequest } from "./common.mapper";

/**
 * ============================================================
 * Resource Mapper (Form + API Mapping)
 * ============================================================
 */

/**
 * ------------------------------------------------------------
 * Resource (UI Form Model)
 * Used for Add/Edit Resource Screen
 * ------------------------------------------------------------
 */
export const resource = {
  resourceId: {
    key: "resourceId",
  },
  venueId: {
    key: "venueId",
  },
  locationId: {
    key: "locationId",
  },
  zoneId: {
    key: "zoneId",
  },
  resourceTypeId: {
    key: "resourceTypeId",
  },
  resourceStatusId: {
    key: "resourceStatusId",
  },

  defaultName: {
    key: "defaultName",
  },
  customName: {
    key: "customName",
  },

  capacity: {
    key: "capacity",
  },

  allowOnline: {
    key: "allowOnline",
  },
  allowWalkIn: {
    key: "allowWalkIn",
  },

  externalResourceId: {
    key: "externalResourceId",
  },

  locationName: {
    key: "locationName",
  },
  resourceTypeName: {
    key: "resourceTypeName",
  },
  resourceStatusName: {
    key: "resourceStatusName",
  },
  zoneName: {
    key: "zoneName",
  },
};

/**
 * ------------------------------------------------------------
 * Resource List Response Mapper
 * Used for Listing Resources in Table View
 * ------------------------------------------------------------
 */
export const resourceListResponse = {
  resourceId: {
    key: "resourceId",
  },

  defaultName: {
    key: "defaultName",
  },

  customName: {
    key: "customName",
  },

  capacity: {
    key: "capacity",
  },

  allowOnline: {
    key: "allowOnline",
  },

  allowWalkIn: {
    key: "allowWalkIn",
  },

  externalResourceId: {
    key: "externalResourceId",
  },

  locationName: {
    key: "locationName",
  },

  resourceTypeName: {
    key: "resourceTypeName",
  },

  resourceStatusName: {
    key: "resourceStatusName",
  },

  zoneName: {
    key: "zoneName",
  },

  createdDate: {
    transform: ({ src }) => {
      return formatDate(src.createdDate, DateTime.C) ?? "-";
    },
  },
};

/**
 * ------------------------------------------------------------
 * Resource Detail Response Mapper
 * Used for Resource Detail API Response
 * ------------------------------------------------------------
 */
export const resourceDetailResponse = {
  resourceId: {
    key: "resourceId",
  },
  venueId: {
    key: "venueId",
  },
  locationId: {
    key: "locationId",
  },
  zoneId: {
    key: "zoneId",
  },
  resourceTypeId: {
    key: "resourceTypeId",
  },
  resourceStatusId: {
    key: "resourceStatusId",
  },

  defaultName: {
    key: "defaultName",
  },
  customName: {
    key: "customName",
  },

  capacity: {
    key: "capacity",
  },

  allowOnline: {
    key: "allowOnline",
  },
  allowWalkIn: {
    key: "allowWalkIn",
  },

  externalResourceId: {
    key: "externalResourceId",
  },

  locationName: {
    key: "locationName",
  },
  resourceTypeName: {
    key: "resourceTypeName",
  },
  resourceStatusName: {
    key: "resourceStatusName",
  },
  zoneName: {
    key: "zoneName",
  }
};

/**
 * ------------------------------------------------------------
 * Resource List Filter Request Mapper
 * Used for Search + Pagination + Filtering API Calls
 * ------------------------------------------------------------
 */
export const resourceListFilterRequest = {
  ...filterRequest,

  venueId: {
    key: "venueId",
  },

  locationId: {
    key: "locationId",
  },

  zoneId: {
    key: "zoneId",
  },

  resourceTypeId: {
    key: "resourceTypeId",
  },

  resourceStatusId: {
    key: "resourceStatusId",
  },

  page: {
    key: "page",
  },

  pageSize: {
    key: "pageSize",
  },

  searchKey: {
    key: "searchKey",
  },
};

/**
 * ------------------------------------------------------------
 * Resource Request Mapper
 * Used for Create / Update Payload
 * ------------------------------------------------------------
 */
export const resourceRequest = {
  resourceId: {
    key: "id",
  },
  venueId: {
    key: "venueId",
  },

  locationId: {
    key: "locationId",
  },

  zoneId: {
    key: "zoneId",
  },

  resourceTypeId: {
    key: "resourceTypeId",
  },

  resourceStatusId: {
    key: "resourceStatusId",
  },

  defaultName: {
    key: "defaultName",
  },

  customName: {
    key: "customName",
  },

  capacity: {
    key: "capacity",
  },

  allowOnline: {
    key: "allowOnline",
  },

  allowWalkIn: {
    key: "allowWalkIn",
  },

  externalResourceId: {
    key: "externalResourceId",
  },
};
